/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class ProductVmpSyncTransformer extends Transformer {

  static fetch(product) {
    return {
      id: product.id,
      name: product.name,
      productPackagingId: product.product_packaging_id,
      productPackagingName: product.product_packaging_name,
      alcoholPercentage: product.alcohol_percentage,
      ddpVmp: product.ddpVmp,
      retailPriceVmp: product.retailPriceVmp,
      gtin: product.gtin,
      vmp: product.vmp,
      country: product.country,
      vintage: product.vintage,
      producer: product.producer,
      bottleVolume: product.bottle_volume,
      packagingMaterial: product.packaging_material,
      packagingMaterialId: product.packaging_material_id,
      packagingName: product.packaging_name,
      packagingQuantity: product.packaging_quantity,
      corkType: product.cork_type,
      lastChanged: product.last_changed,
      syncDate: product.sync_date,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productVmpSync.js